const TOKEN_KEY = 'dasee_auth_tokens';
const PUSH_TOKEN_SAVED_KEY = 'dasee_push_token_saved';

export const saveTokens = (tokens: {accessToken: string; refreshToken: string}) => {
    localStorage.setItem(TOKEN_KEY, JSON.stringify(tokens));
};

export const loadTokens = (): {accessToken: string; refreshToken: string} | null => {
    const tokens = localStorage.getItem(TOKEN_KEY);
    return tokens ? JSON.parse(tokens) : null;
};

export const removeTokens = () => {
    localStorage.removeItem(TOKEN_KEY);
};

// 푸시알림 토큰 상태 관리
export const savePushTokenStatus = () => {
    localStorage.setItem(PUSH_TOKEN_SAVED_KEY, 'true');
};

export const loadPushTokenStatus = (): boolean => {
    const saved = localStorage.getItem(PUSH_TOKEN_SAVED_KEY);
    return saved === 'true';
};

export const removePushTokenStatus = () => {
    localStorage.removeItem(PUSH_TOKEN_SAVED_KEY);
};
